import { useEffect } from "react";
import { API_URL } from "../config/constants";

// Tiempo que el paciente pasa con la web abierta, para el Summary del terapeuta.
// Se cuenta mientras la pestaña está visible: al minimizarla o cambiar de
// pestaña deja de sumar. Se envía en tandas para no llamar a la API cada tick.
const TICK_SECONDS  = 15;
const FLUSH_SECONDS = 60;

const useActivityHeartbeat = (enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;

    let pending = 0;

    const flush = () => {
      if (pending <= 0) return;
      const seconds = pending;
      pending = 0;
      fetch(`${API_URL}/me/heartbeat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ seconds }),
        // keepalive: el último envío debe salir aunque se esté cerrando la pestaña.
        keepalive: true,
      }).catch(() => {});
    };

    const tick = () => {
      if (document.visibilityState !== "visible") return;
      pending += TICK_SECONDS;
      if (pending >= FLUSH_SECONDS) flush();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") flush();
    };

    const interval = setInterval(tick, TICK_SECONDS * 1000);
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("pagehide", flush);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pagehide", flush);
      flush();
    };
  }, [enabled]);
};

export default useActivityHeartbeat;
